// eslint-disable-next-line
export default {
  icons: {
    logo: require("@src/assets/logo.svg").default,
    swap: require("@src/assets/icons/swap.svg").default,
    arrowDown: require("@src/assets/icons/arrowDown.svg").default,
    group: require("@src/assets/icons/sortDown.svg").default,
    done: require("@src/assets/icons/done.svg").default,
    autostaking: require("@src/assets/icons/autostaking.svg").default
  }
};
